import { FC } from 'react';

import { HotColumn } from '@handsontable/react';
import { Box } from '@chakra-ui/react';
import { IList } from 'core/API/listApi';
import { eanValidator, listValidator, numberValidator } from '../Validators';
import Grid from '../Grid';
import { MEanPriorityHeader, translateHeaders } from './helpers/HeadersList';
import { AutoCompleteRenderer, NumberRenderer } from './helpers/customRenderers';
import { requireTitle } from './helpers/utils';

export const MEanPriority: FC<{ list: IList; toolId: number; retailers: string[] }> = ({ list, toolId, retailers }) => {
    const translatedHeaders = translateHeaders(MEanPriorityHeader);

    return (
        <Box m={4}>
            <Grid toolId={toolId} headers={MEanPriorityHeader} list={list}>
                <HotColumn title={translatedHeaders[0]} type="text" />
                <HotColumn title={translatedHeaders[1]} validator={eanValidator()} />
                <HotColumn title={translatedHeaders[2]} type="text" validator={numberValidator(true)}>
                    <NumberRenderer hot-renderer />
                </HotColumn>

                <HotColumn
                    title={requireTitle(translatedHeaders[3])}
                    validator={listValidator(retailers)}
                    source={retailers}
                    type="autocomplete"
                >
                    <AutoCompleteRenderer list={retailers} hot-renderer />
                </HotColumn>
            </Grid>
        </Box>
    );
};
